module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.descriptionTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.description01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.description02[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayPanes) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: _vm.tabTitleClass[0]
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.switchPane(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.onglet01[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: _vm.tabTitleClass[1]
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.switchPane(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.onglet02[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: _vm.tabContentClass[0]
  }, _vm._l((_vm.dashboardData.tabs), function(tab, indexTab) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h2', {
      staticClass: "font-w300 push-15"
    }, [_vm._v(" " + _vm._s(_vm.labelTab[_vm.actualLanguage]) + " " + _vm._s(indexTab + 1))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTabName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dashboardData.tabs[indexTab].tabName),
        expression: "dashboardData.tabs[indexTab].tabName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom Onglet/Tab name"
      },
      domProps: {
        "value": (_vm.dashboardData.tabs[indexTab].tabName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dashboardData.tabs[indexTab], "tabName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._l((_vm.dashboardData.tabs[indexTab].sections), function(section, indexSection) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "block-content"
      }, [_c('h3', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(" " + _vm._s(_vm.labelTab[_vm.actualLanguage]) + " " + _vm._s(indexTab + 1) + " : Section " + _vm._s(indexSection + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelSectionSize[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (section.size),
          expression: "section.size"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(section, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "Small"
        }
      }, [_vm._v("Small (1/3)")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Medium"
        }
      }, [_vm._v("Medium (1/2)")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Large"
        }
      }, [_vm._v("Large")])])])]), _vm._v(" "), _c('h4', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(_vm._s(_vm.titleTile[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, _vm._l((section.tiles), function(tile, indexTile) {
        return _c('div', {
          staticClass: "col-xs-12 col-md-12"
        }, [_c('div', {
          staticClass: "block block-bordered block-themed block-content"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('h4', {
          staticClass: "font-w300 push-15"
        }, [_vm._v(" " + _vm._s(_vm.titleTile[_vm.actualLanguage]) + " " + _vm._s(indexTile + 1))]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelTileLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.label),
            expression: "tile.label"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Nom/Name"
          },
          domProps: {
            "value": (tile.label)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(tile, "label", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.agregation),
            expression: "tile.agregation"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "Sum"
          }
        }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Min"
          }
        }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Max"
          }
        }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Avr"
          }
        }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Last"
          }
        }, [_vm._v("Dernière mesure/Last measure")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileIcon[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.icon),
            expression: "tile.icon"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "icon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_vm._m(0, true), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Medium"
          }
        }, [_vm._v("Medium (1/2)")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Large"
          }
        }, [_vm._v("Large")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-6 push"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.favIcon),
            expression: "tile.favIcon"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.faIconList), function(icon) {
          return _c('option', {
            domProps: {
              "value": icon.favIcon
            }
          }, [_vm._v(_vm._s(icon.label))])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('h4', {
          staticClass: "font-w300 push-15"
        }, [_vm._v(" " + _vm._s(_vm.titleTile[_vm.actualLanguage]) + " " + _vm._s(indexTile + 1))])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('custom-dashboard-tile', {
          attrs: {
            "tile": tile
          }
        })], 1)])])])])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-critical align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addTileToSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonAddTile[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('h4', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(_vm._s(_vm.titleGraph[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-critical align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addGraphToSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonAddGraph[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-3"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-danger align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteThisSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-trash fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonDeleteSection[_vm.actualLanguage]))])])])])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12 push"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-left",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addSectionToDashboard(indexTab)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonAddSection[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-left",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTabToDashboard(indexTab)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteTab[_vm.actualLanguage]))])])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addTabToDashboard()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddTab[_vm.actualLanguage]))])])])]), _vm._v("\n\n" + _vm._s(_vm.dashboardData) + "\n\n                    "), _c('div', {
    class: _vm.tabContentClass[1]
  }, [_c('h3', {
    staticClass: "font-w300 push-15"
  }, [_vm._v(" Preview")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option', {
    attrs: {
      "value": "fa fa-plus"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68dca5e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ConfigCustomDashboardV1p00.vue
// module id = 1556
// module chunks = 4